import {Injectable} from '@angular/core';
import {NodeApiService} from '../../../../services/api/network/online/node/node-api.service';
import {ConnectionApiService} from '../../../../services/api/network/online/connection/connection-api.service';
import {MapSummaryStatisticsService} from '../map-summary-statistics/map-summary-statistics.service';
import {StatisticsApiService} from '../../../../services/api/statistics/statistics-api.service';
import {PeerConnectionApiService} from '../../../../services/api/peer-connection/peer-connection-api.service';

@Injectable({
  providedIn: 'root'
})
export class MapSummaryApiService {

  constructor(private mapSummaryStatistics: MapSummaryStatisticsService,
              private statisticsApiService: StatisticsApiService,
              private nodeApiService: NodeApiService,
              private pConApiService: PeerConnectionApiService,
              private connectionApiService: ConnectionApiService) {
  }

  getNodesTotalNew(success, allNodes): void {
    const nodesTotal = [{field: 'NODES', value: allNodes.length, labelStyle: 'total'}];
    success(nodesTotal);
  }

  getNodesDistributionNew(success, allNodes): void {

    const statusObject = this.mapSummaryStatistics.calculateNodesStatusDistribution(allNodes);
    const nodesDistribution =
      [
        {title: 'NORMAL', status: statusObject.normal, image: 'assets/images/network/state/valid_medium.png', cssTitleClass: 'valid'},
        {title: 'FAULT', status: statusObject.fault, image: 'assets/images/network/state/error_medium.png', cssTitleClass: 'error'},
        {title: 'LOCKED', status: statusObject.locked, image: 'assets/images/network/state/warning_medium.png', cssTitleClass: 'warning'}
      ];
    success(nodesDistribution);
  }

  getPeerConnectionsTotalNew(success, allPeerConnections): void {
    const peerConnectionsTotal =
      [
        {field: 'PEER CONNECTIONS', value: allPeerConnections.elements.length, labelStyle: 'total'}
      ];
    success(peerConnectionsTotal);
  }

  getPeerConnectionsDistributionNew(success, allPeerConnections): void {
    const statusObject = this.mapSummaryStatistics.calculatePeerConnectionsStatusDistribution(allPeerConnections.elements);
    const peerConnectionsDistribution =
      [
        {title: 'NORMAL', status: statusObject.normal, image: 'assets/images/network/state/valid_medium.png', cssTitleClass: 'valid'},
        {title: 'FAULT', status: statusObject.fault, image: 'assets/images/network/state/error_medium.png', cssTitleClass: 'error'},
        {title: 'LOCKED', status: statusObject.locked, image: 'assets/images/network/state/warning_medium.png', cssTitleClass: 'warning'}
      ];
    success(peerConnectionsDistribution);
  }

  getConnectionsTotal(success): void {
    this.connectionApiService.getConnections().then(fetchedConnections => {
      const connectionsTotal =
        [
          {field: 'CONNECTIONS', value: fetchedConnections.elements.length, labelStyle: 'total'}
        ];
      success(connectionsTotal);
    });
  }


  getConnectionsDistribution(success): void {
    this.connectionApiService.getConnections().then(fetchedConnections => {
      const statusObject = this.mapSummaryStatistics.calculateConnectionsStatusDistribution(fetchedConnections.elements);
      const connectionsDistribution =
        [
          {title: 'NORMAL', status: statusObject.normal, image: 'assets/images/network/state/valid_medium.png', cssTitleClass: 'valid'},
          {title: 'FAULT', status: statusObject.fault, image: 'assets/images/network/state/error_medium.png', cssTitleClass: 'error'}
        ];
      success(connectionsDistribution);
    });
  }

  getConnectionsTotalNew(success, allConnections): void {
    const connectionsTotal =
      [
        {field: 'CONNECTIONS', value: allConnections.elements.length, labelStyle: 'total'}
      ];
    success(connectionsTotal);
  }


  getConnectionsDistributionNew(success, allConnections): void {
    const statusObject = this.mapSummaryStatistics.calculateConnectionsStatusDistribution(allConnections.elements);
    const connectionsDistribution =
      [
        {title: 'NORMAL', status: statusObject.normal, image: 'assets/images/network/state/valid_medium.png', cssTitleClass: 'valid'},
        {title: 'FAULT', status: statusObject.fault, image: 'assets/images/network/state/error_medium.png', cssTitleClass: 'error'}
      ];
    success(connectionsDistribution);
  }

  getTopRoutes(success, filter, allPcons, allNodes): any {
    const nodesAndPCons = {
      nodes: null,
      pCons: null
    };

    let parameters: any = {};
    if (filter) {
      parameters = {
        dateType: {operator: '=', value: filter.dateType},
        relativeTimeUnit: {operator: '=', value: filter.relativeTimeUnit},
        relativeTimeUnitValue: {operator: '=', value: filter.relativeTimeUnitValue},
        maxRoutes: {operator: '=', value: filter.maxRoutes}
      };
    }

    function getNodeName(nodeId): void {
      if (nodeId) {
        for (const node of nodesAndPCons.nodes) {
          if (node.id === nodeId) {
            return node.name;
          }
        }
      }
      return null;
    }

    function getPConName(pConId): any {
      if (pConId) {
        for (const pCon of nodesAndPCons.pCons.elements) {
          if (pCon.id === pConId) {
            return pCon.name;
          }
        }
      }
      return null;
    }

    function processTopFiveRawData(topRoutes): void {
      for (let i = 0; i < topRoutes.routes.length; i++) {
        topRoutes.routes[i].route = i + 1;
        topRoutes.routes[i].srcNodeName = getNodeName(topRoutes.routes[i].srcNode);
        topRoutes.routes[i].destNodeName = topRoutes.routes[i].destNode ? getNodeName(topRoutes.routes[i].destNode) :
          topRoutes.routes[i].srcNodeName;
        topRoutes.routes[i].srcPeerConnectionName = getPConName(topRoutes.routes[i].srcPeerConnection);
        topRoutes.routes[i].destPeerConnectionName = getPConName(topRoutes.routes[i].destPeerConnection);
      }
      return topRoutes;
    }

    return this.statisticsApiService.getTopRoutes(parameters).subscribe(topRoutes => {
      nodesAndPCons.nodes = this.nodeApiService.getNodesForMapNew({}, allNodes);
      nodesAndPCons.pCons = this.pConApiService.getPConsForMapNew({}, allPcons);
      success(processTopFiveRawData(topRoutes));
    });
  }
}
